<div class="default-dialog-wrapper dialog-wrapper workflow-diagram mat-elevation-z10">
  <div class="flex flex-col workflow-details-container">
    <div class="fixed-header">
      <div class="flex flex-row w-100-percent p-24 pl-40 white-bg">
        <div class="flex basis-full fw-600 mat-headline-5 flow-header mb-0 fs-24">{{selectedTenant.tenantId | titlecase}} - {{selectedTenant.cloudProvider || selectedTenant.targetCloud}} - {{ 'DIALOG.VIEW_CREATION_WORKFLOW' | transloco }}</div>
        <mat-icon svgIcon="close" class="cursor-pointer w-32 h-32" mat-dialog-close></mat-icon>
      </div>
      <mat-divider class="mat-divider ml-26 mr-26 mb-26 mat-divider-horizontal"></mat-divider>
      <div *ngIf="isLoading" class="flex justify-center items-center">
        <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
      </div>
      <div *ngIf="!isLoading">
        <div *ngIf="workflowDetails && animationStart" class="container" [@animation]="animationStart">
          <h1 class="level-1 rectangle">
            <img src="/assets/images/bank.png" [alt]="tenant" class="w-38 w-38">
            <div class="mat-subtitle-1 fs-24 fw-600 mt-10">{{selectedTenant.tenantId | titlecase}}</div>
          </h1>
          <container *ngIf="(selectedTenant.cloudProvider === 'Azure' || selectedTenant.targetCloud === 'Azure')">
            <ol class="level-2-wrapper">
              <li>
                <div class="level-2 rectangle mat-subtitle-2 level-2-pii flex flex-col items-center justify-center">
                  <div class="mb-4">{{'VIEW_WORKFLOW.PII' | transloco}}</div>
                  <ng-container *ngIf="workflowDetails.azure.pii; else subsctionNotCreated">
                    <div class="green-oval mb-4">
                      <mat-icon svgIcon="done" class="w-14 h-16"></mat-icon>
                    </div>
                    <div class="mat-body-2 subscription-created">
                      {{'VIEW_WORKFLOW.SUBSCRIPTION_CREATED' | transloco}}
                    </div>
                  </ng-container>
                  <ng-template #subsctionNotCreated class="mat-body-2 subscription-not-created">
                    <div class="red-oval mb-4">
                      <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                    </div>
                    <div class="mat-body-2 text-center subscription-not-created">
                      {{'VIEW_WORKFLOW.SUBSCRIPTION_NOT_CREATED' | transloco}}
                    </div>
                  </ng-template>
                </div>                
                <ol class="level-3-wrapper pii">
                  <li>
                    <div class="level-3 rectangle mat-subtitle-2 flex flex-col items-center justify-center">           
                      <ng-container *ngIf="tenantDetails?.prodIngress; else ingressNotDeployed">
                        <div class="mat-body-2 text-center subscription-created">
                          {{'VIEW_WORKFLOW.PII_SHARED_INGRESS_DEPLOYED' | transloco}}
                        </div>
                        <div class="flex flex-row mt-24 mat-body-2 fw-400">
                          <div class="flex items-center mr-20">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.SFTP' | transloco}}
                          </div>     
                          <div class="flex items-center">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.FRONT_DOOR' | transloco}}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #ingressNotDeployed>
                        <div class="red-oval mb-4">
                          <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                        </div>
                        <div class="mat-body-2 text-center subscription-not-created">
                          {{'VIEW_WORKFLOW.PII_SHARED_INGRESS_NOT_DEPLOYED' | transloco}}
                        </div>
                      </ng-template>
                    </div>
                  </li>
                  <li>
                    <div class="level-3 rectangle mat-subtitle-2 flex flex-col items-center justify-center">
                      <ng-container *ngIf="tenantDetails?.nonProdIngress; else nonPiiIngressNotDeployed">
                        <div class="mat-body-2 text-center subscription-created">
                          {{'VIEW_WORKFLOW.NONPROD_SHARED_INGRESS_DEPLOYED' | transloco}}
                        </div>
                        <div class="flex flex-row mt-24 mat-body-2 fw-400">
                          <div class="flex items-center mr-20">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.SFTP' | transloco}}
                          </div>     
                          <div class="flex items-center">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.FRONT_DOOR' | transloco}}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #nonPiiIngressNotDeployed>
                        <div class="red-oval mb-4">
                          <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                        </div>
                        <div class="mat-body-2 text-center subscription-not-created">
                          {{'VIEW_WORKFLOW.NONPROD_SHARED_INGRESS_NOT_DEPLOYED' | transloco}}
                        </div>
                      </ng-template>
                    </div>
                  </li>
                  <li>
                    <div class="level-3 rectangle mat-subtitle-2 flex flex-col items-center justify-center">           
                      <ng-container *ngIf="tenantDetails?.prodSharedServices; else serviceNotDeployed">
                        <div class="mat-body-2 text-center subscription-created">
                          {{'VIEW_WORKFLOW.SHARED_SERVICES_DEPLOYED' | transloco}}
                        </div>
                        <div class="flex flex-row mt-24 mat-body-2 fw-400">
                          <div class="flex items-center mr-20 pt-16">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.KEYCLOCK' | transloco}}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #serviceNotDeployed>
                        <div class="red-oval mb-4">
                          <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                        </div>
                        <div class="mat-body-2 text-center subscription-not-created">
                          {{'VIEW_WORKFLOW.SHARED_SERVICES_NOT_DEPLOYED' | transloco}}
                        </div>
                      </ng-template>
                    </div>
                  </li>
                </ol>
              </li>
              <li>
                <div class="level-2 rectangle mat-subtitle-2 flex flex-col items-center justify-center">
                  <div class="mb-4">{{'TENANT_LIST.NON_PROD' | transloco}}</div>
                  <ng-container *ngIf="workflowDetails.azure.nonPii; else nonPiisubsctionNotCreated">
                    <div class="green-oval mb-4">
                      <mat-icon svgIcon="done" class="w-14 h-16"></mat-icon>
                    </div>
                    <div class="mat-body-2 subscription-created">
                      {{'VIEW_WORKFLOW.SUBSCRIPTION_CREATED' | transloco}}
                    </div>
                  </ng-container>
                  <ng-template #nonPiisubsctionNotCreated class="mat-body-2 subscription-not-created">
                    <div class="red-oval mb-4">
                      <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                    </div>
                    <div class="mat-body-2 text-center subscription-not-created">
                      {{'VIEW_WORKFLOW.SUBSCRIPTION_NOT_CREATED' | transloco}}
                    </div>
                  </ng-template>
                </div>  
                <ol class="level-3-wrapper non-prod flex justify-center azure-level-3">
                  <li>
                    <div class="level-3 rectangle mat-subtitle-2 flex flex-col items-center justify-center">           
                      <ng-container *ngIf="tenantDetails?.nonProdSharedServices; else nonPiiServiceNotDeployed">
                        <div class="mat-body-2 text-center subscription-created">
                          {{'VIEW_WORKFLOW.SHARED_SERVICES_DEPLOYED' | transloco}}
                        </div>
                        <div class="flex flex-row mt-24 mat-body-2 fw-400">                               
                          <div class="flex items-center mr-20">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.GITLAB' | transloco}}
                          </div>
                          <div class="flex items-center">
                            <mat-icon svgIcon="done" class="w-16 h-18 mr-10 green"></mat-icon>
                            {{'VIEW_WORKFLOW.KEYCLOCK' | transloco}}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #nonPiiServiceNotDeployed>
                        <div class="red-oval mb-4">
                          <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                        </div>
                        <div class="mat-body-2 text-center subscription-not-created">
                          {{'VIEW_WORKFLOW.SHARED_SERVICES_NOT_DEPLOYED' | transloco}}
                        </div>
                      </ng-template>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </container>
          <container *ngIf="(selectedTenant.cloudProvider === 'AWS' || selectedTenant.targetCloud === 'AWS')">
            <div class="aws">
              <ol class="level-2-wrapper">
                <li>
                  <div class="level-2 rectangle mat-subtitle-2 flex flex-col items-center justify-center">
                    <div class="mb-4">{{'VIEW_WORKFLOW.PROP_PII' | transloco}}</div>
                    <ng-container *ngIf="workflowDetails.aws.prodPii; else subsctionNotCreated">
                      <div class="green-oval mb-4">
                        <mat-icon svgIcon="done" class="w-14 h-16"></mat-icon>
                      </div>
                      <div class="mat-body-2 subscription-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_CREATED' | transloco}}
                      </div>
                    </ng-container>
                    <ng-template #subsctionNotCreated class="mat-body-2 subscription-not-created">
                      <div class="red-oval mb-4">
                        <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                      </div>
                      <div class="mat-body-2 text-center subscription-not-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_NOT_CREATED' | transloco}}
                      </div>
                    </ng-template>
                  </div>
                </li>
                <li>
                  <div class="level-2 rectangle mat-subtitle-2 flex flex-col items-center justify-center">
                    <div class="mb-4">{{'VIEW_WORKFLOW.NON_PROD_PII' | transloco}}</div>
                    <ng-container *ngIf="workflowDetails.aws.nonProdPii; else nonProdPiisubsctionNotCreated">
                      <div class="green-oval mb-4">
                        <mat-icon svgIcon="done" class="w-14 h-16"></mat-icon>
                      </div>
                      <div class="mat-body-2 subscription-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_CREATED' | transloco}}
                      </div>
                    </ng-container>
                    <ng-template #nonProdPiisubsctionNotCreated class="mat-body-2 subscription-not-created">
                      <div class="red-oval mb-4">
                        <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                      </div>
                      <div class="mat-body-2 text-center subscription-not-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_NOT_CREATED' | transloco}}
                      </div>
                    </ng-template>
                  </div>
                </li>
                <li>
                  <div class="level-2 rectangle mat-subtitle-2 flex flex-col items-center justify-center">
                    <div class="mb-4">{{'VIEW_WORKFLOW.NON_PII' | transloco}}</div>
                    <ng-container *ngIf="workflowDetails.aws.nonPii; else nonPiisubsctionNotCreated">
                      <div class="green-oval mb-4">
                        <mat-icon svgIcon="done" class="w-14 h-16"></mat-icon>
                      </div>
                      <div class="mat-body-2 subscription-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_CREATED' | transloco}}
                      </div>
                    </ng-container>
                    <ng-template #nonPiisubsctionNotCreated class="mat-body-2 subscription-not-created">
                      <div class="red-oval mb-4">
                        <mat-icon svgIcon="warning_amber" class="w-14 h-18"></mat-icon>
                      </div>
                      <div class="mat-body-2 text-center subscription-not-created">
                        {{'VIEW_WORKFLOW.SUBSCRIPTION_NOT_CREATED' | transloco}}
                      </div>
                    </ng-template>
                  </div>
                </li>
              </ol>
            </div>
          </container>
        </div>
      </div>
    </div>
  </div>
</div>